import { headerToggle, reveal } from "https://glamazonbeauty.com/cdn/shop/t/77/assets/header.js?v=160411547291639998511764209218";
import { predictiveSearchHandler } from "https://glamazonbeauty.com/cdn/shop/t/77/assets/predictive-search.js?v=35727077354867693451764209218";
import {
  productEventClickHandler,
  productEventMouseEnterHandler,
  productEventMouseLeaveHandler,
  productEventChangeHandler,
} from "https://glamazonbeauty.com/cdn/shop/t/77/assets/product.js?v=45168789469779128531764209218";
import {
  initSlideshows,
  slideshowClickHandler,
  scrollDown,
  scrollUp,
} from "https://glamazonbeauty.com/cdn/shop/t/77/assets/slideshow.js?v=87767984035067048001764209218";
import { localeChangeEventHandler } from "https://glamazonbeauty.com/cdn/shop/t/77/assets/internationalization.js?v=182789918373096953721764209218";
import { hidePoster } from "https://glamazonbeauty.com/cdn/shop/t/77/assets/video.js?v=102748350703896806551764209218";

async function keyupHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  if ("predictiveSearch" in elementData) {
    const query = element.value;
    // predictive-search.js
    return predictiveSearchHandler(query, element);
  }
  if ("preventNegative" in elementData) {
    if (element.value <= 0) {
      element.value = 1;
    }
  }
}

async function closeOpenMenus(element) {
  const openElements = document.querySelectorAll(
    "[data-has-subnavigation][open]"
  );

  if (openElements.length > 1) {
    openElements.forEach((openElement) => {
      if (openElement.children !== element.children) {
        openElement.removeAttribute("open");
      }
    });
  }
}

async function toggleHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  // Place the text cursor in the relevant input field.
  if ("toggleSearch" in elementData) {
    const searchInput = element.querySelector("[data-search-input]");
    return searchInput.focus();
  }

  if ("hasSubnavigation" in elementData) {
    return closeOpenMenus(element);
  }
}

async function clickHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  if ("previousAnnouncement" in elementData) {
    const sliderElement = element.parentElement.querySelector(
      "[data-element-announcement-slider]"
    );
    sliderElement.scrollBy({
      left: sliderElement.offsetWidth * -1,
      top: 0,
      behavior: "smooth",
    });
  }
  if ("nextAnnouncement" in elementData) {
    const sliderElement = element.parentElement.querySelector(
      "[data-element-announcement-slider]"
    );
    sliderElement.scrollBy({
      left: sliderElement.offsetWidth,
      top: 0,
      behavior: "smooth",
    });
  }

  if ("localeChange" in elementData) {
    // internationalization.js
    return localeChangeEventHandler(e, element, elementData);
  }
  if ("eventProduct" in elementData) {
    // product.js
    return productEventClickHandler(e, element, elementData);
  }
  if ("eventSlideshow" in elementData) {
    // slideshow.js
    return slideshowClickHandler(e, element, elementData);
  }
  if ("showHeader" in elementData) {
    const header = document.getElementById("shopify-section-header");
    return reveal(header);
  }

  if ("videoPoster" in elementData) {
    return hidePoster(element);
  }

  if ("videoPoster" in elementData) {
    return hidePoster(element);
  }

  if ("scrollDown" in elementData) {
    const thumbnails = element
      .closest("product-media")
      .querySelector(".thumbnails");
    scrollDown(thumbnails);
  }

  if ("shareContent" in elementData) {
    e.preventDefault();
    if (navigator.share) {
      navigator
        .share({
          title: "WebShare API Demo",
          url: document.location,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      element
        .closest("ul")
        .querySelector("[data-variant-url]")
        .toggleAttribute("hidden");
    }
  }
  if (element.href) {
    if (element.href.includes("#RE2d9m")) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "RE2d9m"]);
    }
  }

  // Handle dialog triggers
  if ("dialogTrigger" in elementData) {
    let dialogId = elementData.dialogTrigger;

    // Remove 'shopify-section-' prefix if present
    if (dialogId.startsWith("shopify-section-")) {
      dialogId = dialogId.replace("shopify-section-", "");
    }

    const dialog = document.getElementById("app-dialog-" + dialogId);
    if (dialog) {
      dialog.showModal();
    }
  }
}

async function scrollHandler(e) {
  // header.js
  return headerToggle();
}

async function resizeHandler() {
  if (self.innerWidth >= 990) {
    window.CYBER.isDesktop = true;
  } else {
    window.CYBER.isDesktop = false;
  }
}

async function mouseLeaveHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  if (elementData) {
    if ("eventProduct" in elementData) {
      return productEventMouseLeaveHandler(e, element, elementData);
    }
  }
}

async function mouseEnterHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  if (elementData) {
    if ("eventProduct" in elementData) {
      return productEventMouseEnterHandler(e, element, elementData);
    }
  }
}

async function changeHandler(e) {
  const element = e.target;
  const elementData = element.dataset;
  if (elementData) {
    if ("eventProduct" in elementData) {
      return productEventChangeHandler(e, element, elementData);
    }
  }
}

async function touchStartHandler(e) {
  const element = e.target;
  const elementData = element.dataset;

  if ("eventProduct" in elementData) {
    return productEventMouseEnterHandler(e, element, elementData);
  }
}

async function touchEndHandler(e) {
  try {
    const element = e.target;
    const elementData = element.dataset;

    if ("eventProduct" in elementData) {
      return productEventMouseOutHandler(e, element, elementData);
    }
  } catch (err) {
    //console.log(err);
  }
}

export async function addAllEventListeners() {
  // events that bubble
  // loadHandler();

  initSlideshows();

  window.addEventListener("scroll", scrollHandler, false);
  window.addEventListener("resize", resizeHandler, false);
  window.addEventListener("change", changeHandler, false);
  window.addEventListener("touchstart", touchStartHandler, false);
  window.addEventListener("touchend", touchEndHandler, false);

  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keyup", keyupHandler, false);

  // events that do not bubble, element must be caught on capture phase
  document.addEventListener("toggle", toggleHandler, true);
  document.addEventListener("mouseenter", mouseEnterHandler, true);
  document.addEventListener("mouseleave", mouseLeaveHandler, true);
}

if (document.readyState === "complete") {
  const videos = document.querySelectorAll("[data-autoplay]");
  videos.forEach((video) => {
    video.play();
  });
} else {
  window.addEventListener("load", function (e) {
    const videos = document.querySelectorAll("[data-autoplay]");
    videos.forEach((video) => {
      video.play();
    });
  });
}
